'use strict';
/**
 * @file calendar.js
 * @author dxh
 */



    require('../coord/calendar/Calendar');
    require('../coord/calendar/CalendarModel');
    require('./calendar/CalendarView');





//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/calendar.js
// module id = 911
// module chunks = 0